import { render, staticRenderFns } from "./CatalogueView.vue?vue&type=template&id=76164ff2&"
import script from "./CatalogueView.vue?vue&type=script&lang=js&"
export * from "./CatalogueView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueView.vue?vue&type=style&index=0&id=76164ff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports